import React from 'react';
import NewsAnalysis from '../components/financial/NewsAnalysis';

const NewsAnalysisPage = () => {
  return <NewsAnalysis />;
};

export default NewsAnalysisPage;
